import axios from 'axios';

export default {
    async tryCreatePromocode(email) {
        return (await axios.post('/api/component/demo_creation/promocode', { email })).data;
    },
};
